import { Field_Type } from "../constants/enum";

/**
 * Mapping of Field_Type values to display labels with helper descriptions
 */
export const FIELD_TYPE_LABELS: Record<number, string> = {
  [Field_Type.RADIO]: "Radio (Add at least 2 subfeatures/options)",
  [Field_Type.CHECKBOX]: "Checkbox (Add multiple subfeatures/options)",
  [Field_Type.SELECT]: "Select Dropdown (Add dropdown subfeatures/options)",
  [Field_Type.BOOLEAN]: "Boolean (No subfeatures required)",
  [Field_Type.INPUT]: "Input Field (No subfeatures required)",
};

/**
 * Get the display label for a field type value
 * @param value The Field_Type enum value
 * @returns The display label with description
 */
export const getFieldTypeLabel = (value: number | string): string => {
  const numValue = Number(value);
  return FIELD_TYPE_LABELS[numValue] || `Unknown (${numValue})`;
};
